
import { mapGetters } from 'vuex';
export default {
  name: 'GoogleMap',
  props: {
    isHotel: {
      type: Boolean,
      default: false,
    },
    fromLocation: {
      type: String,
      default: '',
    },
    toLocation: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      departure: 'destination/getCurrentDeparture',
      destination: 'destination/getCurrentDestination',
      currentHotelProduct: 'hotel/getCurrentHotelProduct',
      busHotelMode: 'bus-hotel/busHotelMode',
    }),
    link () {
      if (this.isHotel) {
        return `https://www.google.com/maps/embed/v1/place?key=AIzaSyCcYf0WGGUK4Yoyg4n0DQny0Hu2Jo71W-g&q=${
          this.currentHotelProduct
            ? this.currentHotelProduct.name.replace(/& /g, '')
            : this.toLocation
        }`;
      } else if (this.busHotelMode) {
        const formattedFromLocation = this.fromLocation.replace(/[#&]/g, '');
        const formattedToLocation = this.toLocation.replace(/[#&]/g, '');
        return `https://www.google.com/maps/embed/v1/directions?key=AIzaSyCcYf0WGGUK4Yoyg4n0DQny0Hu2Jo71W-g&origin=${formattedFromLocation}&destination=${formattedToLocation}&mode=driving`;
      } else {
        // fyi: use waypoints option to show only one route instead of all possible routes (same as for origin and destination)
        return this.departure && this.destination
          ? `https://www.google.com/maps/embed/v1/directions?key=AIzaSyCcYf0WGGUK4Yoyg4n0DQny0Hu2Jo71W-g&origin=${this.departure.countryName},${this.departure.provinceName},${this.departure.name}&destination=${this.destination.countryName},${this.destination.provinceName},${this.destination.name}&waypoints=${this.departure.name}|${this.destination.name}&mode=driving`
          : `https://www.google.com/maps/embed/v1/place?key=AIzaSyCcYf0WGGUK4Yoyg4n0DQny0Hu2Jo71W-g&q=${
              this.departure
                ? `${this.departure.countryName},${this.departure.provinceName},${this.departure.name}`
                : 'Montreal'
            }`;
      }
    },
  },
};
